/* import __COLOCATED_TEMPLATE__ from './completed-list.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';

export default class CompletedList extends Component {
  get titleComponent() {
    return 'stats-system/list/checklist/header/completed-title';
  }
}
